import React from "react";
import { Navigate } from "react-router-dom";
import AuthService from "../../hooks/AuthService";

const Private = ({ children, adminOnly }) => {
  if (!AuthService.isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && !AuthService.isAdmin()) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default Private;
